import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DigitalContractState } from "./index";

const initialState: DigitalContractState = {
  contracts: [],
  contract: null,
  loading: false,
  filters: { page: 1, page_size: 10 },
  count: 0,
  refresh: 0,
  refreshLoader: false,
};

export const digitalContractSlice = createSlice({
  name: "digitalContract",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setContracts: (state, action) => {
      const { contracts, count } = action.payload;
      state.contracts = contracts;
      state.count = count;
      state.refreshLoader = false;
    },
    setContract: (state, action) => {
      state.contract = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
      state.refresh += 1;
      state.refreshLoader = true;
    },
    resetFilters: (state) => {
      state.filters = initialState.filters;
      state.refresh += 1;
      state.refreshLoader = true;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.filters.page = action.payload;
      state.refresh += 1;
      state.refreshLoader = true;
    },
    addContract: (state, action) => {
      state.contracts.unshift(action.payload);
      state.count += 1;
    },
    updateContract: (state, action) => {
      const { id, contract } = action.payload;
      const index = state.contracts.findIndex(
        (item: any) => item._id === id
      );
      if (index !== -1) {
        state.contracts[index] = contract;
      }
      state.contract = contract;
    },
    updateEmailCount: (state, action) => {
      const { id } = action.payload;
      const index = state.contracts.findIndex(
        (item: any) => item._id === id
      );
      if (index !== -1) {
        state.contracts[index].sendEmailCount += 1;
      }
    },
    refresh: (state) => {
      state.refresh += 1;
    },
  },
});

export const digitalContractActions = digitalContractSlice.actions;
export default digitalContractSlice.reducer;

